import { Grid, Typography, Box, Button } from "@mui/material";
import { brandingConstants } from "../../PreviewStyles/constants";
import { handleConvertPxToPt } from "../helpers";

interface IProps {
  previewAgent: boolean;
  branding: any;
  technology: string;
  page: number;
}

const FooterPreview = ({
  previewAgent,
  branding,
  technology,
  page,
}: IProps) => {
  return (
    <>
      {page !== 5 && (
        <Grid
          item
          container
          flexDirection="column"
          xs={12}
          mb={1}
          mt={previewAgent ? "30px" : "20px"}
          flexBasis="unset"
        >
          {page !== 5 && (
            <Box display="flex">
              <Button
                variant="contained"
                sx={{
                  boxShadow: "none",
                  backgroundColor:
                    branding?.[brandingConstants.secondaryButtonBGColor],
                  color:
                    branding?.[brandingConstants?.secondaryButtonTextColor],
                  minWidth: previewAgent ? "150px" : "80px",
                  minHeight: previewAgent ? "50px" : "20px",
                  fontSize: handleConvertPxToPt(
                    branding?.[brandingConstants.secondaryButtonFontSize],
                    previewAgent
                  ),
                  fontFamily:
                    branding?.[brandingConstants.secondaryButtonFontFamily],
                  fontWeight:
                    branding?.[brandingConstants?.secondaryButtonFontWeight],

                  fontStyle:
                    branding?.[brandingConstants.secondaryButtonFontStyle],
                  marginRight: previewAgent ? "40px" : "10px",
                  border: `1px solid ${
                    branding?.[brandingConstants.secondaryButtonBorderColor]
                  }`,
                  borderRadius:
                    technology !== "rokuTv"
                      ? branding?.[
                          brandingConstants.secondaryButtonBorderRadius
                        ]
                      : "0px",
                  "&:hover": {
                    backgroundColor:
                      branding?.[brandingConstants.secondaryButtonBGColor],
                    boxShadow: "none",
                  },
                  padding: previewAgent ? "20px" : "20px 15px",
                  height: previewAgent ? "auto" : "40px",
                  textTransform: "capitalize",
                }}
              >
                Cancel
              </Button>
              {page !== 1 && (
                <Button
                  variant="contained"
                  sx={{
                    boxShadow: "none",
                    backgroundColor:
                      branding?.[brandingConstants.secondaryButtonBGColor],
                    color:
                      branding?.[brandingConstants?.secondaryButtonTextColor],
                    minWidth: previewAgent ? "150px" : "80px",
                    fontSize: handleConvertPxToPt(
                      branding?.[brandingConstants.secondaryButtonFontSize],
                      previewAgent
                    ),
                    fontFamily:
                      branding?.[brandingConstants.secondaryButtonFontFamily],
                    fontWeight:
                      branding?.[brandingConstants?.secondaryButtonFontWeight],
                    fontStyle:
                      branding?.[brandingConstants.secondaryButtonFontStyle],
                    marginRight: previewAgent ? "40px" : "10px",
                    border: `1px solid ${
                      branding?.[brandingConstants.secondaryButtonBorderColor]
                    }`,
                    borderRadius:
                      technology !== "rokuTv"
                        ? branding?.[
                            brandingConstants.secondaryButtonBorderRadius
                          ]
                        : "0px",
                    "&:hover": {
                      backgroundColor:
                        branding?.[brandingConstants.secondaryButtonBGColor],
                      boxShadow: "none",
                    },
                    padding: previewAgent ? "20px" : "20px 15px",
                    height: previewAgent ? "auto" : "40px",
                    textTransform: "capitalize",
                  }}
                >
                  Back
                </Button>
              )}

              <Button
                variant="contained"
                sx={{
                  boxShadow: "none",
                  backgroundColor:
                    branding?.[brandingConstants.primaryButtonBGColor],
                  color: branding?.[brandingConstants?.primaryButtonTextColor],
                  minWidth: previewAgent ? "150px" : "80px",
                  fontSize: handleConvertPxToPt(
                    branding?.[brandingConstants.primaryButtonFontSize],
                    previewAgent
                  ),
                  fontFamily:
                    branding?.[brandingConstants.primaryButtonFontFamily],
                  fontWeight:
                    branding?.[brandingConstants?.primaryButtonFontWeight],

                  fontStyle:
                    branding?.[brandingConstants.primaryButtonFontStyle],
                  border: `1px solid ${
                    branding?.[brandingConstants.primaryButtonBorderColor]
                  }`,
                  borderRadius:
                    technology !== "rokuTv"
                      ? branding?.[brandingConstants.primaryButtonBorderRadius]
                      : "0px",
                  "&:hover": {
                    backgroundColor:
                      branding?.[brandingConstants.primaryButtonBGColor],
                    boxShadow: "none",
                  },
                  padding: previewAgent ? "20px" : "20px 15px",
                  height: previewAgent ? "auto" : "40px",
                  textTransform: "capitalize",
                }}
              >
                {page !== 5 ? "Next" : "Submit"}
              </Button>
            </Box>
          )}

          <Grid container justifyContent="end" mt="auto">
            <Typography
              sx={{
                fontSize: previewAgent ? 12 : 5,
                color: "#04000054",
              }}
            >
              <span
                style={{
                  color: branding?.[brandingConstants.inputLabelColor],
                  opacity: 0.5,
                }}
              >
                Powered by
              </span>{" "}
              <b>
                <span
                  style={{
                    color: branding?.[brandingConstants.inputLabelColor],
                    opacity: 0.5,
                  }}
                >
                  Cuvo
                </span>
              </b>{" "}
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default FooterPreview;
